import React from "react";
import PropTypes from "prop-types";
import "./Navigation.scss";
import { ReactComponent as Arrow } from "./ArrowDown.svg";

export const CustomPrevButton = (props: {
  page: any;
  pages: any;
  handlePrevClick: any;
}) => {
  const { page, handlePrevClick } = props;
  if (page === 1) {
    return (
      <p onClick={handlePrevClick} className="prev-btn-disabled">
        <Arrow />
      </p>
    );
  }

  return (
    <p onClick={handlePrevClick} className="prev-btn">
      <Arrow />
    </p>
  );
};
CustomPrevButton.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  handlePrevClick: PropTypes.func.isRequired
};

export const CustomNextButton = (props: {
  page: any;
  pages: any;
  handleNextClick: any;
}) => {
  const { page, pages, handleNextClick } = props;
  if (page === pages) {
    return (
      <p onClick={handleNextClick} className="next-btn-disabled">
        <Arrow />
      </p>
    );
  }

  return (
    <p onClick={handleNextClick} className="next-btn">
      <Arrow />
    </p>
  );
};
CustomNextButton.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  handleNextClick: PropTypes.func.isRequired
};

export const CustomPages = (props: { page: any; pages: any }) => {
  const { page, pages } = props;
  return (
    <p className="count">
      Page {page} / {pages}
    </p>
  );
};
CustomPages.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired
};
